import {z} from '@hono/zod-openapi';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {optionItemSchema} from '../common/OptionItemSchema';

const fileItemSchema = z.object({
  fileId: z.string(),
  fileName: z.string(),
  sourceFormat: z.literal('NISSAN_DIGLAS').optional(),
});

export type FileItem = z.infer<typeof fileItemSchema>;

const zipItemSchema = z
  .object({
    zipId: z.string(),
    fileName: z.string(),
    sourceFormat: z.string().optional(),
  })
  .refine(({sourceFormat}) => sourceFormat === undefined, {
    message: 'Structured source formats are supported only for original files',
    path: ['sourceFormat'],
  });

export type ZipItem = z.infer<typeof zipItemSchema>;

export const extractDeliveryNoteDocumentRequestSchema = z
  .object({
    files: z.array(fileItemSchema).optional(),
    zips: z.array(zipItemSchema).optional(),
    suppliers: z.array(optionItemSchema),
    units: z.array(optionItemSchema),
    vat: z.array(optionItemSchema),
  })
  .refine((data) => isNotNilOrEmpty(data.files) || isNotNilOrEmpty(data.zips), {
    message: 'At least one of files or zips must be provided',
  });

export type ExtractDeliveryNoteDocumentRequest = z.infer<
  typeof extractDeliveryNoteDocumentRequestSchema
>;
